module.exports = __webpack_public_path__ + "static/media/sz.d00ba664.svg";